import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { ActiveFilterList } from './components/ActiveFilterList/ActiveFilterList';
import { ClearFiltersButton } from './components/ClearFiltersButton/ClearFiltersButton';
import { translations } from './translations';

import styles from './ActiveFilters.module.scss';

interface Props {
  className?: string;
}

export const ActiveFilters: FunctionComponent<Props> = ({ className }) => {
  const rootClassnames = classnames(styles.root, className);

  return (
    <section className={rootClassnames}>
      <div className={styles.header}>
        <p className={styles.title}>{translations.title}</p>
        <ClearFiltersButton />
      </div>
      <ActiveFilterList className={styles.list} />
    </section>
  );
};

ActiveFilters.displayName = 'ActiveFilters';
